<!-- 课程 -->
<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="dialogVisible" width="550px" top="200px"
        :modal-append-to-body="false">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="已选择职位：">
                <span class="color_red">{{ postForm.biddings.length }}个</span>
            </el-form-item>
            <el-form-item :class="'box'" label="">
                <span>
                    我的报价
                </span>
                <span class="padding_5">
                    =
                </span>
                <span>
                    每个职位市场报价
                </span>
                <span class="padding_5">
                    +
                </span>
                <span class="color_red">
                    我的增加价格
                </span>
            </el-form-item>
            <el-form-item label="我的增加价格：" prop="quoted_price">
                <el-input placeholder="请输入报价..." v-model="ruleForm.quoted_price">
                    <template slot="append">
                        <span class="color_red">元</span>
                    </template>
                </el-input>
            </el-form-item>
        </el-form>

        <!-- v-if  从新渲染 -->
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleOk">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>

        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            title: '批量竞价',
            ruleForm: {
               
            },
            postForm: {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: []
            },
            options: JSON.parse(localStorage.getItem('entinfolist')),
            rules: {
                outline_name: [
                    { required: true, message: '请输入课程名称', trigger: 'blur' },

                ],
                enterprise_id: [
                    { required: true, message: '请选择所属企业', trigger: 'change' }
                ],
            }
        }
    },
    created() {

    },
    methods: {
        init(data) {
            this.ruleForm = {
                quoted_price: '',
            }
            this.postForm = {
                'enterprise_id': localStorage.getItem('enterprise_id'),
                'enterprise_name': '',
                biddings: data.map(item => {
                    return {
                        'recruitment_id': item.recruitment_id,
                        'quoted_price': item.max_bidding_price,
                    }
                })
            }
            let obj = this.recursion(this.options)

            this.postForm.enterprise_name = obj.enterprise_name
        },
        handleClose(done) {

            done();

        },
        handleOk() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.postForm.biddings.forEach(item => {
                        item.quoted_price =Number(item.quoted_price)+Number(this.ruleForm.quoted_price)
                    })

                    

                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.biddingApplicationBatchAdd, {
                            data: this.postForm
                        }).then((res) => {
                            if (res.data.code == 0) {
                                this.$message({ type: "success", message: '添加成功' });
                                this.$emit('ok')
                                this.dialogVisible = false


                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        }).catch((err) => {
                            // this.loading = false; 
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.postForm.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        handleChange(value) {
            console.log(value);
            let obj = this.recursion(this.options)

            this.ruleForm.enterprise_name = obj.enterprise_name
        },

        getOptions() {


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingOutlineTree, {
                    data: this.postForm3
                }).then((res) => {
                    if (res.data.code == 0) {
                        res.data.data.forEach(item => {
                            item.fold = true
                        })
                        this.options = res.data.data


                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
    }
}
</script>

<style lang="less" scoped>
/deep/ .box{
    .el-form-item__content{
        margin-left: 0 !important;
    }
}
</style>
